import { get, post, put, del } from '../../api-config';
import { gdpService, getLocale } from './_service';

// Search & basic
export const getPatients = async (data: any) => await post(gdpService, '/patients/search', data, null);
export const getDuplicatePatients = async (data: any) =>
  await post(gdpService, '/patients/findDuplicates', data, null);
export const postPatients = (data: any) => post(gdpService, '/patients', data, null);

export const getPatient = (id: any) => get(gdpService, `/patients/${id}`, null, null);
export const getPatientNotMeasuredStatus = (id: any) =>
  get(gdpService, `/patients/${id}/not-measured-status`, null, null);
export const putPatient = (data: any) => put(gdpService, '/patients', data, null);
export const getPatientLastLocation = (id: any) =>
  get(gdpService, `/patients/${id}/lastLocation`, null, null);

// Communication / contact
export const getSms = async (id: any, params: any) =>
  await get(gdpService, `/patients/${id}/sms`, null, params);
export const tokenPatient = async (id: any) =>
  await get(gdpService, `/patients/${id}/token`, null, null);
export const getVideoCallOpen = (id: any) => get(gdpService, `/patients/${id}/videocall/open`, null, null);
export const getVideoCallClose = (id: any) => get(gdpService, `/patients/${id}/videocall/close`, null, null);

// Relations
export const getPatientRelations = (data: any) =>
  get(gdpService, `/patients/${data.id}/relations`, null, {
    accesses: data.accesses,
    init: data.init,
    size: data.size,
  });
export const deletePatientRelation = (data: any) =>
  del(gdpService, `/patients/${data.userId}/relations/${data.relationId}`);
export const putRelationships = (patientId: any, relationId: any, data: any) =>
  put(gdpService, `/patients/${patientId}/relations/${relationId}`, data, null);
export const postRelationships = (patientId: any, data: any) =>
  post(gdpService, `/patients/${patientId}/relations`, data, null);

// Patient notes
export const postAddNote = (data: any) =>
  post(gdpService, `/patients/${data.referenceId}/notes`, data, null);
export const getPatientNotes = (data: any) =>
  get(gdpService, `/patients/${data.id}/notes`, null, { init: data.init, size: data.size });
export const getPatientNotesAllTypes = (data: any) =>
  get(gdpService, `/patients/${data.id}/notes/all-types`, null, { init: data.init, size: data.size });
export const deletePatientNotes = (data: any) =>
  del(gdpService, `/patients/${data.referenceId}/notes/${data.noteId}`);

// Patient actions
export const getPatientActions = (data: any) =>
  get(gdpService, `/patients/${data.id}/events`, null, { init: data.init, size: data.size });
export const postPatientActionsSearch = (data: any) =>
  post(gdpService, `/patients/${data.id}/events/search`, data, null);
export const getPatientLastActions = (data: any) =>
  get(gdpService, `/patients/${data.id}/last-events`, null, { init: data.init, size: data.size });

// Patient notifications
export const getPatientNotifications = (data: any) =>
  get(gdpService, `/patients/${data.id}/notifications`, null, { init: data.init, size: data.size });
export const getUserUnreadNotificationsCount = (userId: any) =>
  get(gdpService, `/patients/${userId}/notifications/unread-count`, null, null);
export const postPatientNotification = (data: any) =>
  post(gdpService, `/patients/${data.patientId}/notification`, data, null);
export const putPatientNotification = (data: any) =>
  put(gdpService, `/patients/${data.patientId}/notification/${data.id}`, data, null);
export const putPatientNotificationSend = (data: any) =>
  put(gdpService, `/patients/${data.patientId}/notification/${data.id}/send`, data, null);
export const putPatientNotificationSeen = (data: any) =>
  put(gdpService, `/patients/${data.patientId}/notification/${data.id}/seen`, data, null);
export const putPatientNotificationResponse = (data: any, params: any) =>
  put(gdpService, `/patients/${data.patientId}/notification/${data.id}/response`, data, params);
export const deletePatientNotification = (data: any) =>
  del(gdpService, `/patients/${data.userId}/notification/${data.id}`);

// Device link
export const putDeviceUser = (data: any) => put(gdpService, `/patients/link`, data, null);
export const putUnlinkDeviceUser = (data: any) => put(gdpService, `/patients/unlink`, data, null);

// Service state
export const getServicesState = () =>
  get(gdpService, `/patients/serviceStates`, null, { locale: getLocale() });
export const getHistoricServiceState = (data: any) =>
  get(gdpService, `/patients/${data.id}/serviceStates/historic`, null, {
    init: data.init,
    size: data.size,
  });
export const putServiceState = (id: any, data: any) =>
  put(gdpService, `/patients/${id}/serviceStates`, data, null);
export const postServiceState = (id: any, data: any) =>
  post(gdpService, `/patients/${id}/serviceStates`, data, null);
export const postAddHistoricServiceStateNote = (data: any) =>
  post(gdpService, `/patients/${data.patientId}/serviceStates/historic/${data.referenceId}/notes`, data, null);
export const getPatientServiceStateOptions = (id: any) =>
  get(gdpService, `/patients/${id}/serviceStates/options`, null, null);

// Campos mínimos que le faltan al paciente AHORA para poder avanzar el estado del
// servicio. Mismo cálculo que aplica el backend al bloquear el cambio, así que la
// lista nunca se desfasa respecto a lo que realmente bloquea.
export const getPatientMissingRequiredFields = (id: any) =>
  get(gdpService, `/patients/${id}/required-fields/missing`, null, null);

// Service type
export const putServiceType = (id: any, data: any) =>
  put(gdpService, `/patients/${id}/service-types`, data, null);
export const postServiceType = (id: any, data: any) =>
  post(gdpService, `/patients/${id}/service-types`, data, null);
export const getPatientServiceTypeOptions = (id: string) =>
  get(gdpService, `/patients/${id}/service-types/options`, null, { locale: getLocale() });

// Fecha prevista de baja del servicio. El GET devuelve item = null cuando el servicio no se ha activado
// nunca; el PUT la fija a mano (o la deja en blanco = indefinido) y la marca como MANUAL.
export const getPatientServiceExpiration = (id: string) =>
  get(gdpService, `/patients/${id}/service-expiration`, null, null);
export const putPatientServiceExpiration = (id: string, data: any) =>
  put(gdpService, `/patients/${id}/service-expiration`, data, null);

// Service configuration
export const getServiceConfiguration = (id: any) =>
  get(gdpService, `/patients/${id}/service-configuration`, null, null);
export const putServiceConfiguration = (id: any, serviceId: any, data: any) =>
  put(gdpService, `/patients/${id}/service-configuration/${serviceId}`, data, null);
export const postServiceConfiguration = (id: any, data: any) =>
  post(gdpService, `/patients/${id}/service-configuration`, data, null);

// Terms
export const getTermsAndConditionsAgreement = (data: any) =>
  get(gdpService, `/patients/${data.id}/termsAndConditionsAgreement`, null, {
    init: data.init,
    size: data.size,
  });

// Service contact
export const getServiceContactWay = () =>
  get(gdpService, `/serviceContactWay`, null, { locale: getLocale() });

// Historic
export const getHistoricUserDevices = (data: any) =>
  get(gdpService, `/patients/${data.id}/devices/historic`, null, {
    init: data.init,
    size: data.size,
  });
